/**
 * Returns a value from nested objects - returning null if it does not exist.
 *
 * e.g.
 * const example = { inner_obj{  other_inner: 5  } };
 * pick(example, ['inner_obj', 'other_inner']); // returns 5
 * pick(example, ['other_value', 'other_inner']); // returns null
 */
const pick = (object, properties, defaultVal = null) => {
  if (typeof object !== 'object') {
    return null;
  }

  let value = object;

  properties.forEach((property) => {
    if (!value || typeof value !== 'object') {
      value = null;
    } else if (!value[property]) {
      value = null;
    } else {
      value = value[property];
    }
  });

  if (value === null || value === undefined) {
    return defaultVal;
  }

  return value;
};

export default pick;
